import { takeLatest, call, put, select } from 'redux-saga/effects';

import quoteService from 'services/quoteService';

import { getQuoteId } from 'store/quotes/selectors';

import { types, getRelatedRevisions } from './actions';

export default function* root() {
  yield takeLatest(types.OPEN_REVISION_DRAWER, watchOpenRevisionDrawer);
}

function* watchOpenRevisionDrawer() {
  try {
    const quoteId = yield select(getQuoteId);
    yield put(getRelatedRevisions.request());
    const relatedRevisions = yield call(
      quoteService.getRelatedRevisions,
      quoteId,
    );
    yield put(getRelatedRevisions.success({ relatedRevisions }));
  } catch (error) {
    yield put(getRelatedRevisions.error(error));
  }
}
